import { IOption } from '../interfaces';
import AxiosService from '../utils/axios-service';

export class OptionService extends AxiosService {
  private static instance: OptionService;

  constructor() {
    super('BFF_HELP_CENTER_URL');
  }

  static get getInstance(): OptionService {
    if (!OptionService.instance) {
      OptionService.instance = new OptionService();
    }
    return OptionService.instance;
  }

  public async findAll(categoryId: string): Promise<any> {
    try {
      const url: string = 'option/findAll';
      const response: IOption[] = await this.axios.post(url, { status: true, categoryId });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async findAllWithSuboption(categoryId: string): Promise<any> {
    try {
      const url: string = 'option/findAllWithSuboption';
      const response: IOption[] = await this.axios.post(url, { status: true, categoryId });
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default OptionService.getInstance;
